module.exports = __webpack_public_path__ + "static/media/tape.5a6214ea.svg";